import { makeStyles } from '@material-ui/core';
import { calculateHeight } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles(() => ({
  loginMenuButtonTextContainer: {
    flex: 1,
  },
  loginMenuIconContainer: {
    paddingTop: calculateHeight(19).stringValue,
    height: calculateHeight(24).stringValue,
  },
}));
